import { theme } from '@/styles/theme';

export const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  successBackground: {
    maxWidth: 770,
    maxHeight: 770,
    borderRadius: 4,
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      width: 370,
    },
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingBottom: 4,
  },
  textTitle: {
    color: 'white',
    fontWeight: 600,
    fontSize: '16px',
    paddingBottom: 3,
  },
  textDescription: {
    fontWeight: 400,
    textAlign: 'center',
    color: 'white',
    fontSize: '12px',
  },
  button: {
    width: '40%',
    border: '0.5px solid white',
    color: 'white',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '60%',
    },
  },
  checkIcon: {
    paddingBottom: 2,
    [theme.breakpoints.down('sm')]: {
      width: 100,
      paddingTop: 4,
      paddingBottom: 0,
    },
  },
  medStationIcon: {
    paddingBottom: 4,
    width: '17%',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 1,
    },
  },
};
